module.exports = __webpack_public_path__ + "img/follaje.a5a0ff77.jpg";